import React from "react";
import { Tag } from "antd";
import moment from "moment";
import { CA_STATUS_LABELS, CA_STATUS_COLORS } from "./correctiveActionHelpers";

const rowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  flexWrap: "wrap",
  marginBottom: 16,
  padding: "10px 12px",
  background: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
};

const metaStyle = { fontSize: 12, color: "#667085" };

/**
 * Live status of a corrective action, read from the incident_corrective_actions
 * row rather than the investigation's stored JSON. Renders nothing until the
 * action has been created (which happens on investigation approval).
 */
const CorrectiveActionStatus = ({ action }) => {
  const persisted = action?.persisted;
  if (!persisted) return null;

  const status = persisted.status || "assigned";

  return (
    <div style={rowStyle}>
      <Tag color={CA_STATUS_COLORS[status] || "default"} style={{ marginRight: 0 }}>
        {CA_STATUS_LABELS[status] || status}
      </Tag>
      {persisted.assigned_to_name && (
        <span style={metaStyle}>Assigned to {persisted.assigned_to_name}</span>
      )}
      {persisted.due_date && (
        <span style={metaStyle}>
          Due {moment(persisted.due_date).format("DD/MM/YYYY")}
        </span>
      )}
      {persisted.completed_at && (
        <span style={metaStyle}>
          Completed {moment(persisted.completed_at).format("DD/MM/YYYY")}
        </span>
      )}
      {Array.isArray(persisted.reallocation_history) &&
        persisted.reallocation_history.length > 0 && (
          <span style={metaStyle}>
            Reallocated {persisted.reallocation_history.length}{" "}
            {persisted.reallocation_history.length === 1 ? "time" : "times"}
          </span>
        )}
    </div>
  );
};

export default CorrectiveActionStatus;
